import UserImage from '../../../legacy/React/Components/Common/UserImage';
import { ActionLogData } from '../data';

interface ProfileAvatarProps {
    profileId: string;
    actionLogData: ActionLogData;
}

export const ProfileAvatar = ({ profileId, actionLogData }: ProfileAvatarProps) => {
    const profile = actionLogData.profiles[profileId];

    if (!profile) {
        return null;
    }

    const userId = 'userId' in profile.data.value ? profile.data.value.userId : undefined;
    const imageId = userId != null ? actionLogData.users[userId]?.imageId : undefined;
    return <UserImage imageId={imageId ?? undefined} altText={profile.name} />;
};
